import { BreakpointProvider, SWAThemeProvider } from '@jetstream/themes';
import QuickLinksCardComponent from './QuickLinksCardComponent';

const QuickLinksWrapper = () => {
  return (
    <BreakpointProvider>
      <SWAThemeProvider>
        <QuickLinksCardComponent />
      </SWAThemeProvider>
    </BreakpointProvider>
  );
};

export default QuickLinksWrapper;
